// extracted by mini-css-extract-plugin
export default {"idle":"Idle-module__idle__N6xDBuO","copilotRun":"Idle-module__copilotRun__GCwsoOJ"};